function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fileLinkDownLoad, getFileType } from '@/libs/public';
import SettingMer from '@/libs/settingMer';
import imageViewer from '@/components/common/imageViewer';
import { clientDataDeleteApi, clientDataLabelApi, clientDataStatusApi, getSalesman as _getSalesman, salesmanCustomApi, saveSalesmanCustomApi, customerViewApi, customerSubscribeApi, customerReturnApi, customerLostApi, customerCancelLostApi, customerClaimApi, customerImport } from '@/api/enterprise';
import ExportExcel from '@/components/common/exportExcel';
import importExcel from '@/components/common/importExcel';
export default {
  name: 'FinanceList',
  components: {
    ExportExcel: ExportExcel,
    importExcel: importExcel,
    imageViewer: imageViewer,
    recordUpload: function recordUpload() {
      return import('@/views/customer/list/components/recordUpload');
    },
    dialogForm: function dialogForm() {
      return import('./components/index');
    },
    editCustomer: function editCustomer() {
      return import('./components/editCustomer');
    },
    selectLabel: function selectLabel() {
      return import('@/components/form-common/select-label');
    },
    addContract: function addContract() {
      return import('@/views/customer/contract/components/addContract');
    },
    transferDialog: function transferDialog() {
      return import('@/views/customer/list/components/transferDialog');
    },
    VisibleDialog: function VisibleDialog() {
      return import('@/components/form-common/dialog-transfer');
    },
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    },
    types: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      returnForm: {
        reason: ''
      },
      dialogVisible: false,
      dialogShow: false,
      returnShow: false,
      resource: '',
      fromData: {},
      formBoxConfig: {},
      gettime: '',
      formInfo: {
        avatar: '',
        type: 'add',
        show: 1,
        data: {},
        follow_id: 0
      },
      defaultCheckedKeys: [],
      treeData: [{
        label: '全部',
        value: '',
        group: 1
      }, {
        label: '我关注的',
        value: 'concern',
        group: 1
      }, {
        label: '未成交',
        value: 'unsettled',
        group: 2
      }, {
        label: '已成交',
        value: 'traded',
        group: 2
      }, {
        label: '急需跟进',
        value: 'urgent_follow_up',
        group: 1
      }],
      fileLinkDownLoadUrl: '',
      tableData: [],
      tab: '',
      labelText: '',
      fileList: [],
      salesmanList: [],
      defaultFrame: '',
      where: {
        page: 1,
        limit: 15,
        types: this.types,
        scope_frame: 'all'
      },
      total: 0,
      type: '1',
      labelData: {},
      id: null,
      ids: [],
      eid: null,
      contractFromData: {},
      transferData: {},
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableItemDialogVisible: false,
      defaultTableItemList: [],
      transferDataList: [],
      visibleTableItemList: [],
      getSalesmanCustom: [],
      tableHeaders: [],
      // 表格的表头
      searchSelect: [],
      srcList: [],
      rule: {
        reason: [{
          required: true,
          message: '请输入备注信息',
          trigger: 'blur'
        }]
      },
      checkedId: [],
      pageHeight: 0,
      prevHeight: 0,
      formHeight: 0,
      saveName: '',
      exportData: {
        data: [],
        cols: [{
          wpx: 130
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 120
        }, {
          wpx: 130
        }, {
          wpx: 130
        }, {
          wpx: 110
        }, {
          wpx: 110
        }]
      },
      search: [],
      dropdownList: [{
        label: '设置标签',
        value: 1
      }, {
        label: '移交同事',
        value: 2
      }, {
        label: '分配',
        value: 5
      }, {
        label: '领取',
        value: 6
      }, {
        label: '标为流失',
        value: 7
      }, {
        label: '退回公海',
        value: 3
      }, {
        label: '导出',
        value: 4
      }, {
        label: '导入',
        value: 8
      }],
      viewSearch: []
    };
  },
  created: function created() {
    var dropdownValueList = [1, 2, 3, 4, 8];
    if (this.types == 3) {
      dropdownValueList = [1, 5, 6, 7, 4, 8];
    }
    for (var i = 0; i < this.dropdownList.length; i++) {
      if (!dropdownValueList.includes(this.dropdownList[i].value)) {
        this.dropdownList.splice(i, 1);
        i--;
      }
    }
    this.where.types = this.types;
    var query = this.$route.query;
    if (query.id && query.name) {
      this.where.name = query.name;
    }
    this.defaultFrame = '';
    this.getSalesman();
    this.salesmanCustom();
  },
  mounted: function mounted() {
    if (this.types == 2) {
      this.where.scope_frame = 'self';
    } else {
      this.where.scope_frame = 'all';
    }
    this.getTableData();
  },
  computed: {
    fileUrl: function fileUrl() {
      return SettingMer.https + "/client/import";
    },
    // treeData分组
    treeDataGroup: function treeDataGroup() {
      var treeData = [];
      if (this.types != 3) {
        for (var i = 0; i < this.treeData.length; i++) {
          if (!i || this.treeData[i].group != this.treeData[i - 1].group) {
            treeData.push({
              options: []
            });
          }
          treeData[treeData.length - 1].options.push(this.treeData[i]);
        }
      }
      return treeData;
    }
  },
  methods: {
    focusEvt: function focusEvt(item) {
      var _this = this;
      var status = item.customer_followed ? 0 : 1;
      customerSubscribeApi(item.id, status).then(function () {
        _this.getTableData();
      });
    },
    toSrcIcon: function toSrcIcon(name) {
      return getFileType(name);
    },
    // 关闭显示列弹框
    handleCloseTableItem: function handleCloseTableItem() {
      this.tableItemDialogVisible = false;
    },
    handleConfirmVisible: function handleConfirmVisible(array) {
      var _this2 = this;
      var data = {
        select_type: 'list_select',
        data: array
      };
      saveSalesmanCustomApi(this.types, data).then(function (res) {
        _this2.tableItemDialogVisible = false;
        _this2.tableHeaders = [];
        _this2.salesmanCustom();
        _this2.getTableData();
      });
    },
    mapDict: function mapDict(dict) {
      for (var i = 0; i < dict.length; i++) {
        dict[i].name = dict[i].label;
        if (dict[i].children) {
          this.mapDict(dict[i].children);
        }
      }
    },
    salesmanCustom: function salesmanCustom() {
      var _this3 = this;
      salesmanCustomApi(this.types).then(function (res) {
        var search_select_list = res.data.search_select;
        var search_list = res.data.search;
        var search = [];
        var searchs = [];
        var viewSearch = [];
        for (var i = 0; i < search_list.length; i++) {
          if (search_list[i].input_type == 'date') {
            search_list[i].input_type = 'date_picker';
          }
          if (search_list[i].field == 'customer_label') {
            search_list[i].input_type = 'tag';
          }
          if (search_list[i].input_type == 'select') {
            if (search_list[i].field == 'area_cascade') {
              search_list[i].input_type = 'cascader_address';
            } else if (search_list[i].type == 'single') {
              search_list[i].input_type = 'cascader_radio';
            } else if (search_list[i].type == 'multiple') {
              search_list[i].input_type = 'cascader';
            }
          }
          if (search_list[i].dict) {
            _this3.mapDict(search_list[i].dict);
          }
          search_list[i].form_value = search_list[i].input_type;
          search_list[i].field_name_en = search_list[i].field;
          search_list[i].field_name = search_list[i].name;
          search_list[i].title = search_list[i].name;
          search_list[i].options = search_list[i].dict;
          search_list[i].type = search_list[i].input_type;
          search_list[i].is_city_show = '';
          search_list[i].is_city_show = '';
          if (search_select_list.includes(search_list[i].field)) {
            search.push(search_list[i]);
          } else {
            viewSearch.push(search_list[i]);
          }
        }
        searchs = [search[1], search[2], search[0]];
        _this3.search = searchs;
        _this3.viewSearch = viewSearch;
        var _res$data = res.data,
          list = _res$data.list,
          list_select = _res$data.list_select;
        _this3.transferDataList = list;
        _this3.defaultTableItemList = list_select;
        var fieldMap = res.data.list.reduce(function (map, item) {
          map[item.field] = item;
          return map;
        }, {});
        var searchMap = res.data.search.reduce(function (map, item) {
          map[item.field] = item;
          return map;
        }, {});
        // 按 list_select 顺序提取数据
        _this3.tableHeaders = res.data.list_select.map(function (field) {
          return fieldMap[field];
        }).filter(function (item) {
          return item;
        });
        _this3.$nextTick(function () {
          _this3.$refs.table.doLayout();
        });
        _this3.getSalesmanCustom = res.data;
      });
    },
    customSearchEvt: function customSearchEvt() {
      this.tableItemDialogVisible = true;
    },
    getTable: function getTable() {
      this.getTableData();
    },
    // 添加跟进记录
    handleFollowUp: function handleFollowUp(item) {
      this.formInfo.data.eid = item.id;
      this.dialogShow = true;
    },
    recordChange: function recordChange() {
      this.dialogShow = false;
    },
    getTableData: function getTableData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this4.loading) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this4.loading = true;
              _this4.where.statistics_type = _this4.labelText;
              if (_this4.types == 2) {
                _this4.where.scope_frame = 'self';
              }
              _context.next = 7;
              return customerViewApi(_this4.where);
            case 7:
              res = _context.sent;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.loading = false;
              _this4.$nextTick(function () {
                _this4.$refs.table.doLayout();
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.where.page = 1;
      this.getTableData();
    },
    getSalesman: function getSalesman() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getSalesman();
            case 2:
              result = _context2.sent;
              _this5.salesmanList = result.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleNodeClick: function handleNodeClick(data) {
      this.labelText = data.value;
      this.where.page = 1;
      if (data) {
        this.where.follows = data.value;
      } else {
        this.where.follows = '';
      }
      this.getTableData(this.labelText);
    },
    // 下载模板
    exportTemplate: function exportTemplate() {
      this.gettime = this.$moment(new Date()).format('YYYY-MM-dd HH:mm:ss');
      fileLinkDownLoad(this.fileLinkDownLoadUrl, '客户合同导入模板' + this.gettime + '.xlsx');
    },
    // 导出列表数据
    exportList: function exportList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var listField, title, aoaData, obj, key, listData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this6.total > 1000)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", _this6.$message.error('超出限制，最大支持导出1000条数据'));
            case 2:
              listField = _this6.transferDataList.filter(function (item) {
                return item.type && !['images', 'file', 'oaWangeditor'].includes(item.type);
              });
              _this6.saveName = '导出客户(' + _this6.$moment(new Date()).format('MMDDHHmmss') + ').xlsx';
              title = [];
              listField.map(function (item) {
                title.push(item.name);
              });
              aoaData = [title];
              if (!_this6.loading) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("return");
            case 9:
              _this6.loading = true;
              obj = {
                types: _this6.types,
                scope_frame: _this6.where.scope_frame,
                statistics_type: _this6.labelText,
                page: 0,
                limit: 0,
                is_export: 1
              };
              for (key in _this6.where) {
                if (_this6.where[key]) {
                  obj[key] = _this6.where[key];
                }
              }
              obj.page = 0;
              obj.limit = 0;
              _context3.next = 16;
              return customerViewApi(obj);
            case 16:
              listData = _context3.sent;
              if (listData.data.list.length > 0) {
                listData.data.list.forEach(function (value) {
                  var arr = [];
                  for (var i = 0; i < listField.length; i++) {
                    arr.push(_this6.getFieldValue(listField[i], value[listField[i].field]));
                  }
                  aoaData.push(arr);
                });
                _this6.exportData.data = aoaData;
                _this6.$refs.exportExcel.exportExcel();
              } else {
                _this6.$message.error('暂无数据');
              }
              _this6.loading = false;
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getFieldValue: function getFieldValue(field, val) {
      if (field.type === 'checked') {
        return val.map(function (item) {
          return typeof item == 'string' ? item : item.name || '';
        }).join('/');
      } else if (field.type === 'single') {
        if (Array.isArray(val)) {
          return val.join('/');
        } else if (field.field === 'customer_status') {
          return val > 1 ? '已流失' : val ? '已成交' : '未成交';
        }
        return val || '';
      } else if (field.type === 'radio') {
        for (var key in field.dict) {
          if (parseInt(field.dict[key].value) === parseInt(val)) {
            return field.dict[key].label || '';
          }
        }
      } else if (field.type === 'multiple') {
        var arr = val.map(function (item) {
          return item.join('/');
        });
        if (field.input_type === 'select') {
          if (arr.length === 1) {
            return arr[0] + '#';
          } else {
            return arr.join('#');
          }
        } else {
          return arr.join(',');
        }
      } else if (field.type === 'salesman') {
        return val ? val.name : '';
      } else {
        return val || '';
      }
    },
    // 添加客户
    addFinance: function addFinance(str, row) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.formBoxConfig = {
                title: str === 'edit' ? '编辑客户' : '新增客户',
                width: '570px'
              };
              _this7.$refs.dialogForm.openBox(_this7.types, row, str);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 查看
    handleCheck: function handleCheck(item) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              item.eid = item.id;
              item.cid = 0;
              _this8.fromData = {
                title: _this8.$t('customer.editcustomer'),
                width: '1000px',
                data: item,
                types: _this8.types
              };
              _this8.$refs.editCustomer.tabIndex = '1';
              _this8.$refs.editCustomer.tabNumber = 1;
              _this8.$refs.editCustomer.openBox(item.id, _this8.types);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handleTransfer: function handleTransfer(type) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (this.ids.length <= 0 && type === 1) {
        this.$message.error(this.$t('customer.placeholder22'));
      } else {
        var ids = [];
        if (type === 1) {
          // 批量
          this.ids.map(function (value) {
            ids.push(value.id);
          });
        } else {
          if (this.ids.length > 0) {
            this.$refs.table.clearSelection();
          }
          ids.push(row.id);
        }
        this.transferData = {
          title: type === 1 ? '移交其他同事' : this.$t('customer.transfersettings'),
          width: '520px',
          type: 1,
          ids: ids
        };
        this.$refs.transferDialog.handleOpen();
      }
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          page: 1,
          limit: 15,
          types: this.types,
          scope_frame: this.types == 2 ? 'self' : 'all',
          cid: '',
          name: '',
          label: [],
          follows: '',
          time: '',
          salesman_id: ''
        };
        this.labelText = '';
        this.getTableData('');
      } else {
        if (this.types !== 2 && data.scope_frame && data.scope_frame.length > 0) {
          data.scope_frame = data.scope_frame[0];
        }
        this.where.page = 1;
        for (var key in data) {
          this.where[key] = data[key];
        }
        this.getTableData();
      }
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this9.$modalSure(_this9.$t('customer.message06'));
            case 2:
              _context6.next = 4;
              return clientDataDeleteApi(item.id);
            case 4:
              if (_this9.where.page > 1 && _this9.tableData.length <= 1) {
                _this9.where.page--;
              }
              _context6.next = 7;
              return _this9.getTableData();
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    followFn: function followFn() {
      var data = {
        status: this.resource,
        types: 0
      };
      this.handleStatus(this.eid, data);
      this.dialogVisible = false;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 关注
    handleFollow: function handleFollow(row, type) {
      var status = null;
      status = type === 1 ? row.follow === 0 ? 1 : 0 : row.up_follow === 0 ? 1 : 0;
      var data = {
        status: status,
        types: 1
      };
      this.handleStatus(row.id, data);
    },
    // 修改状态与关注
    handleStatus: function handleStatus(id, data) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return clientDataStatusApi(id, data);
            case 2:
              _context7.next = 4;
              return _this10.getTableData();
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handleLabelConf: function handleLabelConf(res, id) {
      var data = [];
      var label = [];
      if (res.list.length <= 0) {
        this.$message.error(this.$t('customer.placeholder58'));
      } else {
        if (id) {
          data.push(id.id);
        } else if (!id) {
          this.ids.map(function (value) {
            data.push(value.id);
          });
        }
        res.list.map(function (value) {
          label.push(value.id);
        });
        this.batchSetLabel({
          data: data,
          label: label
        });
      }
    },
    handleLabel: function handleLabel(row) {
      this.$refs.selectLabel.handlePopoverShow();
    },
    // 退回公海
    handleReturn: function handleReturn(type, row) {
      if (this.ids.length <= 0 && type === 1) {
        this.$message.error(this.$t('customer.placeholder22'));
      } else {
        var checkedId = Array.from(this.checkedId);
        if (row) {
          this.id = [row.id];
        }
        this.returnShow = true;
      }
    },
    cancel: function cancel() {
      this.returnForm.reason = '';
      this.returnShow = false;
    },
    // 确定退回公海
    submit: function submit() {
      var _this11 = this;
      var checkedId = Array.from(this.checkedId);
      var data = {
        data: checkedId.length ? checkedId : this.id,
        reason: this.returnForm.reason
      };
      this.$refs.returnForm.validate(function (valid) {
        if (valid) {
          customerReturnApi(data).then(function (res) {
            _this11.cancel();
            _this11.getTableData();
          });
        }
      });
    },
    // 标为流失
    markedLoss: function markedLoss(row, val) {
      var _this12 = this;
      if (this.checkedId.length == 0 && val !== 1) {
        return this.$message.error('至少选择一项');
      }
      var checkedId = Array.from(this.checkedId);
      var id = checkedId.length && val !== 1 ? checkedId : [row.id];
      if (row && row.customer_status == 2) {
        this.$modalSure(this.$t('您确定要将此客户取消流失吗')).then(function () {
          customerCancelLostApi(row.id);
          setTimeout(function () {
            _this12.getTableData();
          }, 300);
          _this12.salesmanCustom();
        });
      } else {
        this.$modalSure(this.$t('您确定要将此客户标为流失吗')).then(function () {
          customerLostApi({
            data: id
          });
          setTimeout(function () {
            _this12.getTableData();
          }, 300);
          _this12.salesmanCustom();
        });
      }
    },
    //领取客户
    receive: function receive(type, row) {
      var _this13 = this;
      if (this.ids.length <= 0 && type === 1) {
        this.$message.error(this.$t('customer.placeholder22'));
      } else {
        var checkedId = Array.from(this.checkedId);
        var id = checkedId.length ? checkedId : [row.id];
        this.$modalSure(this.$t('您确定要领取此客户吗')).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return customerClaimApi({
                  data: id
                });
              case 2:
                _context8.next = 4;
                return _this13.getTableData();
              case 4:
                _context8.next = 6;
                return _this13.salesmanCustom();
              case 6:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        })));
      }
    },
    // 批量设置标签
    batchSetLabel: function batchSetLabel(data) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return clientDataLabelApi(data);
            case 2:
              _this14.id = null;
              _this14.ids = [];
              _this14.getTableData();
              _this14.tab = 1;
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    labelGroup: function labelGroup(val) {
      var data = [];
      var label = [];
      this.ids.map(function (value) {
        data.push(value.id);
      });
      label = val.ids;
      this.batchSetLabel({
        data: data,
        label: label
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkedId = val.map(function (item) {
        return item.id;
      });
      this.ids = val;
    },
    // 添加合同
    addContract: function addContract(row) {
      this.contractFromData = {
        title: this.$t('customer.addcontract'),
        id: row.id,
        name: row.name,
        edit: false,
        width: '570px'
      };
      this.$refs.addContract.openBox();
    },
    addDataFn: function addDataFn() {
      this.addFinance();
    },
    dropdownFn: function dropdownFn(item, val) {
      switch (item.value) {
        case 1:
          this.labelGroup(val);
          break;
        case 2:
        case 5:
          this.handleTransfer(1);
          break;
        case 3:
          this.handleReturn(1);
          break;
        case 4:
          this.exportList();
          break;
        case 6:
          this.receive(1);
          break;
        case 7:
          this.markedLoss();
          break;
        case 8:
          this.$refs.importExcel.btnClick();
          break;
      }
    },
    importExcelData: function importExcelData(arrRes) {
      var _this15 = this;
      var thead = arrRes[0];
      var data = [];
      for (var i = 1; i < arrRes.length; i++) {
        data.push({});
        for (var j = 0; j < arrRes[i].length; j++) {
          data[data.length - 1][thead[j]] = arrRes[i][j];
        }
      }
      customerImport(this.types, data).then(function (res) {
        _this15.getTableData('');
      });
    }
  }
};